import React from 'react';
import './JournalEntryCard.css';

// One journal entry rendered as a card. `image` (session-level, not per-entry) is only
// passed for the entry that should show the AI reflection artwork - pending/ready/failed.
function JournalEntryCard({ role, content, image }) {
  return (
    <div className={`journal-entry-card journal-entry-${role}`}>
      {image && (
        <div className="journal-entry-image">
          {image.status === 'ready' && image.url ? (
            <img src={image.url} alt="AI reflection of this entry" loading="lazy" />
          ) : image.status === 'failed' ? (
            <div className="journal-entry-image-placeholder journal-entry-image-failed">
              <span>Image unavailable</span>
            </div>
          ) : (
            <div className="journal-entry-image-placeholder journal-entry-image-pending">
              <span className="journal-drawing-spinner" aria-hidden="true" />
              <span>Drawing your reflection…</span>
            </div>
          )}
        </div>
      )}
      <div className="journal-entry-text">
        <p className="journal-entry-content">{content}</p>
      </div>
    </div>
  );
}

export default JournalEntryCard;
